// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import axios from 'axios';
// import { t } from 'i18next';
// import React, { useEffect, useState } from 'react';
// import baseURL from '../helper/axiosHelper';
// import { useSelector } from 'react-redux';
// import { updatedCart } from '../../features/updatedCartSlice';
// import { Table } from 'semantic-ui-react';
// import { defaultImage } from '../../constants';

// const AddCartItem = ({
//   title,
//   description = 'Details',
//   price,
//   doc,
//   cartID,
//   index,
//   handleDeleteItem,
//   file_Stream,
//   templateName,
//   descriptionEn,
//   titleEn,
//   value,
//   setDatanotfound,
// }) => {
//   const isActive = useSelector((state) => state.toggle.isActive);
//   const [quantity, setQuantity] = useState(0);
//   const [token, setToken] = useState(false);
//   const [totalPrice, setTotalPrice] = useState(price);
//   useEffect(() => {
//     // Update totalPrice when quantity changes
//     setTotalPrice(price * quantity);
//   }, [price, quantity, updatedCart]);

//   useEffect(() => {
//     setToken(!!localStorage.getItem('token'));
//   }, []);

//   const handleDelete = async () => {
//     // Remove item from localStorage
//     localStorage.removeItem(title);
//     // Trigger onDelete function to refresh cart list

//     if (token) {
//       await axios.delete(`${baseURL}/Cart/DeleteCart`, {
//         headers: {
//           id: cartID,
//         },
//       });
//     }

//     handleDeleteItem(index);
//   };
//   return (
//     <Table.Row className="align-middle ">
//       {/* {doc || file_Stream ? (
//         <td className="py-2 px-4 border-b">
//           <img
//             src={`data:image/jpeg;base64,${doc ?? file_Stream}`}
//             width={60}
//             className="rounded-lg w-20 h-20  lg:me-10"
//             alt={title}
//           />
//         </td>
//       ) : (
//         <img src={`data:image/jpeg;base64,${defaultImage}`} width={60} className="rounded-lg w-20 h-20  lg:me-10" alt={title} />
//       )} */}
//       {doc || file_Stream ? (
//         <td className="py-2 px-4 border-b">
//           {familyMembersCount > 0 ? (
//             <img
//               src="/assets/sponsor_images/Family.png"
//               width={60}
//               className="rounded-lg w-20 h-20 lg:me-10"
//               alt={title}
//             />
//           ) : (
//             <img
//               src={
//                 genderNameEn === 'Male'
//                   ? '/assets/sponsor_images/Male.png'
//                   : '/assets/sponsor_images/Female.png'
//               }
//               width={60}
//               className="rounded-lg w-20 h-20 lg:me-10"
//               alt={title}
//             />
//           )}
//         </td>
//       ) : (
//         <img
//           src={`data:image/jpeg;base64,${defaultImage}`}
//           width={60}
//           className="rounded-lg w-20 h-20 lg:me-10"
//           alt={title}
//         />
//       )}
//       <td className="py-2 px-4 border-b ">
//         <span className="md:text-md font-medium text-customgreen ">{isActive ? title : titleEn}</span>
//         {/* <span className={`"text-xs font-light text-customgreen  ${isActive? "inline-block w-[360px]" : ""} "`}>{isActive ? description : descriptionEn}</span> */}
//       </td>

//       {/* <div className="flex flex-col ml-3">
//         <span className="md:text-md text-customgreen font-medium">Category</span>
//       </div> */}

//       <td className="border-b py-2 px-4 whitespace-nowrap">
//         <span className="text-xs mx-1 text-customgreen font-medium">
//           {price} {t('AED')}
//         </span>
//         <span className={`text-red-500 cursor-pointer`}>
//           {/* Delete button */}
//           <DeleteOutlineIcon onClick={handleDelete} />
//         </span>
//       </td>
//     </Table.Row>
//   );
// };

// export default React.memo(AddCartItem);

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import axios from 'axios';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import baseURL from '../helper/axiosHelper';
import { useSelector } from 'react-redux';
import { updatedCart } from '../../features/updatedCartSlice';
import { Table } from 'semantic-ui-react';
import { defaultImage } from '../../constants';

const AddCartItem = ({
  title,
  description = 'Details',
  price,
  doc,
  cartID,
  index,
  handleDeleteItem,
  file_Stream,
  templateName,
  descriptionEn,
  titleEn,
  value,
  setDatanotfound,
  sourceType,
  genderNameEn

}) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [quantity, setQuantity] = useState(0);
  const [token, setToken] = useState(false);
  const [totalPrice, setTotalPrice] = useState(price);
  const [cartData, setCartData] = useState(null);

  useEffect(() => {
    // Get cart data from localStorage
    const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
    const currentItem = storedCart.find((item) => item.titleAr === title || item.titleEn === title);
    setCartData(currentItem);
  }, [title]);

  useEffect(() => {
    setTotalPrice(price * quantity);
  }, [price, quantity, updatedCart]);

  useEffect(() => {
    setToken(!!localStorage.getItem('token'));
  }, []);

  const handleDelete = async () => {
    localStorage.removeItem(title);
    if (token) {
      await axios.delete(`${baseURL}/Cart/DeleteCart`, {
        headers: {
          id: cartID,
        },
      });
    }
    handleDeleteItem(index);
  };

  return (
    <Table.Row className="align-middle">
      {cartData?.sourceType == 3 || sourceType==3 ? (
        <td className="py-2 px-4 border-b">
          {cartData?.familyMembersCount > 0 ? (
            <img
              src="/assets/sponsor_images/Family.png"
              width={60}
              className="rounded-lg w-20 h-20 lg:me-10"
              alt={title}
            />
          ) : (
            <img
              src={
                cartData?.genderNameEn === 'Male'|| genderNameEn === 'Male'
                  ? '/assets/sponsor_images/Male.png'
                  : '/assets/sponsor_images/Female.png'
              }
              width={60}
              className="rounded-lg w-20 h-20 lg:me-10"
              alt={title}
            />
          )}
        </td>
      ) : (
        // <img
        //   src={`data:image/jpeg;base64,${defaultImage}`}
        //   width={60}
        //   className="rounded-lg w-20 h-20 lg:me-10"
        //   alt={title}
        // />
        <td className="py-2 px-4 border-b">
          <img
            src={`data:image/jpeg;base64,${doc ? doc : file_Stream ?file_Stream : defaultImage }`}
            width={60}
            className="rounded-lg w-20 h-20  lg:me-10"
            alt={title}
          />
        </td>
      )}
      <td className="py-2 px-4 border-b">
        <span className="md:text-md font-medium text-customgreen">{isActive ? title : titleEn}</span>
      </td>
      <td className="border-b py-2 px-4 whitespace-nowrap">
        <span className="text-xs mx-1 text-customgreen font-medium">
          {price} {t('AED')}
        </span>
        <span className={`text-red-500 cursor-pointer`}>
          <DeleteOutlineIcon onClick={handleDelete} />
        </span>
      </td>
    </Table.Row>
  );
};

export default React.memo(AddCartItem);
